import { cn } from "@/utils/cn";

type Tone = "primary" | "accent" | "secondary" | "neutral";

interface StatCardProps {
  icon: string;
  label: string;
  value: string;
  hint?: string;
  tone?: Tone;
}

const tones: Record<Tone, string> = {
  primary: "bg-primary-50 text-primary-600",
  accent: "bg-accent-50 text-accent-700",
  secondary: "bg-secondary-50 text-secondary-600",
  neutral: "bg-background-100 text-foreground-600",
};

export default function StatCard({ icon, label, value, hint, tone = "primary" }: StatCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <span className={cn("flex h-10 w-10 items-center justify-center rounded-lg", tones[tone])}>
        <i className={cn(icon, "text-lg")} aria-hidden="true" />
      </span>
      <p className="mt-4 font-heading text-2xl font-semibold leading-none text-foreground-950">{value}</p>
      <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{label}</p>
      {hint && <p className="mt-1 text-xs text-foreground-400">{hint}</p>}
    </div>
  );
}